module.exports = __webpack_public_path__ + "img/Id2.e594be17.png";